import React from 'react'
import styled, { css } from 'styled-components'

import Header, { HeaderHeightPx } from 'components/header'
import GlobalMenu from 'components/global-menu'
import { useAuthProvider } from 'contexts/auth'
import { ViewMode } from 'schema/common'
import theme from 'styles/theme'

const LayoutContainer = styled.div`
  background-color: ${theme.BACKGROUND_SURFACE};
`

interface LayoutProps {
  children?: React.ReactNode
  type: ViewMode
  infiniteScroll: boolean
  customHeader?: React.ReactNode
  width?: string
  showBackButton?: boolean
}

const Container = styled.div`
  position: relative;
  display: block;
  width: 100%;
  min-height: calc(100vh - ${HeaderHeightPx});
  margin: 0 auto;
  padding-top: ${HeaderHeightPx};
  background-color: ${(p) => p.theme.BACKGROUND_BASE};
`

const GuestLayout = (props: { type: ViewMode; width?: string }) => {
  const { type, width } = props
  if (type === 'guest') {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: ${width || '660px'};
      min-height: calc(100vh - ${HeaderHeightPx});
      margin: 0 auto;

      @media only screen and (max-width: ${(p) => p.theme.vp}px) {
        width: max-content;
      }
    `
  }

  return css``
}

const Contents = styled.div<{
  type: ViewMode
  infiniteScroll: boolean
  width?: string
}>`
  width: 100%;
  max-width: ${(p) => p.theme.vp}px;
  margin: 0 auto;
  padding: ${(p) => (p.infiniteScroll ? '0 30px' : '50px 30px')};
  box-sizing: border-box;
  ${(p) => GuestLayout({ type: p.type, width: p.width })};

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    padding: ${(p) =>
      p.infiniteScroll ? '0 30px' : `${p.theme.space.xl} ${p.theme.space.l} `};
    width: 100%;
  }
`

const Layout = ({
  type = 'user',
  children,
  infiniteScroll,
  customHeader,
  width,
  showBackButton = false,
}: LayoutProps) => {
  const { currentUser } = useAuthProvider()
  return (
    <LayoutContainer>
      {currentUser && !customHeader && <GlobalMenu />}
      {customHeader || <Header showBackButton={showBackButton} />}
      <Container>
        <Contents type={type} infiniteScroll={infiniteScroll} width={width}>
          {children}
        </Contents>
      </Container>
    </LayoutContainer>
  )
}

export default Layout
